KXL.module('GamesApp.MediaPreview', function (MediaPreview, KXL, Backbone, Marionette, $, _) {
	MediaPreview.Controller = {
		getMediaPreview: function (model) {
			return new MediaPreview.View({model:model});
		}
	};
});
